export enum CommonLabelType {
  /** Упс... */
  BH_CORE_NOT_FOUND_TITLE = 'front.web.core.not.found.title',
  /** Сторінка не знайдена */
  BH_CORE_NOT_FOUND_SUBTITLE = 'front.web.core.not.found.subtitle',
  /** Упс... */
  BH_CORE_ERROR_TITLE = 'front.web.core.error.title',
  /** Внутрішня помилка сервера */
  BH_CORE_ERROR_SUBTITLE = 'front.web.core.error.subtitle',

  /** Політика конфіденційності */
  BH_CORE_PRIVACY_POLICY = 'front.web.core.privacy.policy',
  /** Ліцензійна угода */
  BH_CORE_LICENSE_AGREEMENT = 'front.web.core.license.agreement',

  /** Виберіть дату */
  BH_CORE_COMMON_DATE_PICKER_BUTTON_TEXT = 'front.web.core.common.date.picker.button.text',
}

export type TLabelType = typeof CommonLabelType;

export const LabelType: TLabelType = { ...CommonLabelType };
